import React, {Children, useId} from 'react';
import {ComboBox} from '@pb/kit-component-combo-box';
import {Label} from '@pb/kit-component-label';
import {ElementGroup} from '@pb/kit-component-element-group';
import {hashedClasses, withCssModule} from '@pb/kit-util-with-css-module';

import styles from './styles.module.styl';

import type {SwitcherTypesProps} from '../typedef';


const classes = hashedClasses(styles);
const classNames = withCssModule(styles);

export const OnlyPageSize = (props: SwitcherTypesProps) => {
    const {
        children,
        comboBoxProps,
        disabled,
        onChangePages,
        showSizeSwitcher,
        state,
        switcherLabel,
    } = props;

    const {pageSize} = state;

    const switcherLabelId = useId();
    const comboBoxId = useId();

    const isChildrenValid = Children.count(children) > 0 && !Children.toArray(children).every(child => !child);

    return showSizeSwitcher && isChildrenValid ? (
        <ElementGroup>
            <Label
                id={switcherLabelId}
                ellipsis={false}
                rootProps={{className: classes['only-page-size__label-root']}}
                className={classes['only-page-size__label']}>
                {switcherLabel}
            </Label>
            <ComboBox
                id={comboBoxId}
                aria-labelledby={`${switcherLabelId} ${comboBoxId}`}
                {...{
                    disabled,
                    value: pageSize,
                    onChange: onChangePages,
                    ...comboBoxProps,
                }}
                className={classNames('only-page-size__combo-box', comboBoxProps?.className)}>
                {children}
            </ComboBox>
        </ElementGroup>
    ) : null;
};
